import { Card, Col, Row, Statistic } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined, SyncOutlined, TeamOutlined } from '@ant-design/icons'
import type { SurveyStats } from '../types/survey.types'

interface SurveyStatsCardsProps {
  stats: SurveyStats | null
  loading: boolean
}

export function SurveyStatsCards({ stats, loading }: SurveyStatsCardsProps) {
  return (
    <Row gutter={16} style={{ marginBottom: 16 }}>
      <Col span={6}>
        <Card size="small" loading={loading}>
          <Statistic title="Total Responses" value={stats?.totalResponses || 0} prefix={<TeamOutlined />} />
        </Card>
      </Col>
      <Col span={6}>
        <Card size="small" loading={loading}>
          <Statistic
            title="Completed"
            value={stats?.completedCount || 0}
            prefix={<CheckCircleOutlined />}
            valueStyle={{ color: '#3f8600' }}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card size="small" loading={loading}>
          <Statistic
            title="In Progress"
            value={stats?.inProgressCount || 0}
            prefix={<SyncOutlined />}
            valueStyle={{ color: '#1890ff' }}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card size="small" loading={loading}>
          <Statistic
            title="Dismissed"
            value={stats?.dismissedCount || 0}
            prefix={<CloseCircleOutlined />}
            valueStyle={{ color: '#cf1322' }}
          />
        </Card>
      </Col>
    </Row>
  )
}
